export const TREE_NODE_NAME: string = 'm-tree-node';
export const TREE_ICON_NAME: string = 'm-tree-icon';
